module.exports = __webpack_public_path__ + "img/slide3_img4.6c21a257.png";